import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { Socket } from 'ngx-socket-io';
import { SocketService } from './services/socket.service';
import { setActivatedTimer, setTimers } from './utils/timer.utils';
import { TimerService } from './services/entities/timer.service';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { PushService } from './services/push.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  public loading$: Observable<any>;

  constructor(
    private store: Store<{ loading: boolean }>,
    private socketService: SocketService,
    private timerService: TimerService,
    private afMessaging: AngularFireMessaging,
    private push: PushService
  ) {
    this.loading$ = this.store.select('loading');
  }

  ngOnInit(): void {
    this.timerService.getTimersData().subscribe((data) => {
      setActivatedTimer(data.activeTimer);
      setTimers(data.timers);
    });
    this.socketService.onEvent('reloadTimers').subscribe((timer) => {
      this.timerService.getTimersData().subscribe((data) => {
        setActivatedTimer(data.activeTimer);
        setTimers(data.timers);
      });
    });
    this.socketService.onEvent('activeTimer').subscribe(timer => {
      console.log('activeTimer', timer.name)
      this.push.sendPushNotification(timer);
    })

    navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('Service Worker registrado:', registration);
      this.afMessaging.useServiceWorker(registration);

      // Solicita o token de permissão para notificações
      this.afMessaging.requestToken.subscribe(
        (token) => {
          console.log('Token recebido:', token);
          localStorage.setItem('PUSH_NOTIFICATION_TOKEN', token!);
        },
        (error) => {
          console.error('Erro ao obter token:', error);
        }
      );
    })
    .catch((error) => {
      console.error('Erro ao registrar o Service Worker:', error);
    });
  }
}
